module.exports = __webpack_public_path__ + "img/6F5A9876.62276a76.png";